import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
import { ImageUploadStyle } from './Component.style';
import { useTranslation } from 'react-i18next';

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  padding: 4,
  boxSizing: 'border-box',
};

export default function UploadFiles({
  handleFileSRC,
  value,
  multiple,
  showIcon,
  icon,
  disabled,
  accept,
  imagePreview,
  id,
}) {
  const { t } = useTranslation();
  const [files, setFiles] = useState(value);
  const { getRootProps, getInputProps, isDragAccept, isDragReject } =
    useDropzone({
      accept,
      disabled,
      onDrop: (acceptedFiles) => {
        setFiles(
          acceptedFiles.map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            })
          )
        );
      },
    });

  useEffect(() => {
    if (typeof files !== 'string') {
      handleFileSRC([...value, ...files]);
      return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
    }
  }, [files]);

  const thumbs =
    files?.length > 0 &&
    files?.map((file, index) => (
      <div style={thumb} key={'file' + index}>
        <img
          alt="preview"
          src={file.preview}
          onLoad={() => {
            URL.revokeObjectURL(file.preview);
          }}
        />
      </div>
    ));

  const isActive = isDragAccept || isDragReject;

  return (
    <ImageUploadStyle>
      <section
        className={clsx(
          !showIcon && 'dropzoneImgContainer',
          isActive && 'dropzone-highlight',
          disabled && 'dropzone-disabled'
        )}
      >
        <div {...getRootProps({ className: 'dropzone' })}>
          <div>
            <input {...getInputProps()} multiple={multiple} id={id} />
            {showIcon ? (
              icon
            ) : (
              <>
                {isActive ? (
                  <h4>Drop here to upload</h4>
                ) : (
                  <p>
                    {t('BusinessPlace.DragAndDrop')}{' '}
                    <span className="dropzone-upload-text">{t('BusinessPlace.Upload')}</span>
                  </p>
                )}
                {imagePreview && <div className="previewImg">{thumbs}</div>}
              </>
            )}
          </div>
        </div>
      </section>
    </ImageUploadStyle>
  );
}
